<div class="db-ai-builder-create-page-templates__header">
  <i class="db-icon db-icon-ds-arrow-small" (click)="changeStep({step: 'options'})" *ngIf="!hideBackButton"></i>
  <h2>Pre-made pages</h2>
</div>
<div class="db-ai-builder-create-page-templates__categories">
  <div>
    <p class="mb7"><b>Categories</b></p>
    <ul>
      <li *ngFor="let category of categories" [ngClass]="{'active': category === selectedCategory}">
        <p (click)="filterByCategory(category)" [innerHTML]="category"></p>
      </li>
    </ul>
  </div>

   <!--  <div class="ds-input-wrap enable-theme" *ngIf="!websiteTenWebTheme || (websiteTenWebTheme && !websiteTenWebTheme.active)">
       <input class="ds-checkbox" [formControl]="check" [checked]="check?.value" type="checkbox" id="enable">
       <label for="enable"><span class="mt30" [innerHTML]="'text_enableTenWebTheme' | dbText"></span></label>
     </div>-->

     <div class="add-page">
       <div>
         <button class="ds-btn-blue" [ngClass]="{'ds-btn-disabled': !selectedTemplate?.id}" (click)="runAiBuilder()">
           <i class="db-icon db-icon-ds-diamond mr8" *ngIf="demoUser"></i>
           <span>Add Page</span>
         </button>
         <div class="db-demo-tooltip" *ngIf="demoUser && !selectedTemplate?.id">Unlock this feature with 10Web pro plans. <a (click)="showUpgradePopup.emit('Pre-made')"><span>Try now for free.</span></a></div>
       </div>
       <span>You can add one page at a time</span>
     </div>
</div>

<div class="db-ai-builder-create-page-templates__templates">
  <!--<db-loading-screen *ngIf="!(templates$ | async) || !builderTemplates.length" [pageBlocker]="true"></db-loading-screen>-->
  <div class="card" [ngClass]="{'selected': selectedTemplate?.id === template?.id}"
       *ngFor="let template of filteredBuilderTemplates">
    <img [src]="template.desktopScreenShotUrl" alt="" dbLoaded (loaded)="orderImages()">
    <div *ngIf="selectedTemplate?.id !== template?.id" class="add">
      <div (click)="previewTemplate(template.desktopScreenShotUrl)">
        <i class="db-icon db-icon-ds-eye"></i>
      </div>
      <div (click)="selectTemplate(template)">
        <i class="db-icon db-icon-ds-add"></i>
      </div>
    </div>
    <div *ngIf="selectedTemplate?.id === template?.id" class="checkmark">
      <div>
        <i class="db-icon db-icon-ds-checkmark"></i>
      </div>
    </div>
  </div>
</div>

<div class="db-ai-builder-create-page-templates__preview">

</div>
